module.exports = __webpack_public_path__ + "static/media/dec-pay-statement@2x.905ef202.png";